import { CrudApi } from './CrudApi';
import { VideoClipModel } from '@/models/video/VideoClipModel';

export class VideoClipApi extends CrudApi<VideoClipModel>{
	constructor(apiPrefix: string = 'videoClip'){
		super(apiPrefix, (obj) => new VideoClipModel().load(obj));
	}
}

export const videoClipApi = new VideoClipApi();